const settings = state => state.settings;
const isMaintenance = state => state.isMaintenance;

export {
  settings,
  isMaintenance,
}